"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const MobilePopover_1 = require("../../components/MobilePopover");
const EventPredicateAddEdit = ({ activePopover, isPopoverModalFormOpen, selectedSchemas, getSelectedPredicate, closePopoverModalForm, updateActivePopover, addPredicate, editPredicate, listUpload, fetchLists, lists, device, id, type, children, }) => {
    React.useEffect(() => {
        fetchLists();
    }, []);
    const closePopoverModal = () => {
        if (device === 'Mobile') {
            closePopoverModalForm();
            setTimeout(() => updateActivePopover(''), 500);
            return;
        }
        updateActivePopover('');
    };
    const getRowOnClick = () => {
        if (activePopover === `event-${type}-conditions-${id}`) {
            updateActivePopover('');
        }
        else {
            updateActivePopover(`event-${type}-conditions-${id}`);
        }
    };
    const handleAdd = (predicate) => {
        closePopoverModal();
        if (id == null) {
            addPredicate(predicate);
        }
        else {
            editPredicate(id, predicate);
        }
    };
    const listEnabledKeyPaths = selectedSchemas
        .filter((schema) => schema.attributeType === 'STRING')
        .map((schema) => schema.keyPath);
    const getStyle = () => {
        return type === 'add'
            ? {
                display: 'inline-block',
            }
            : {
                maxWidth: '100%',
            };
    };
    return device !== 'Mobile' ? (React.createElement(src_1.PopoverContainer, { id: `event-${type}-condition-popover-${id}`, popoverProps: {
            placement: 'right',
            device,
        }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: () => getRowOnClick(), showPopover: activePopover === `event-${type}-conditions-${id}`, style: getStyle() },
        children,
        React.createElement(src_1.PredicateBuilder, { attributeType: "Event", popOverTargetParent: "root", schemas: selectedSchemas, device: device, listEnabledKeyPaths: listEnabledKeyPaths, lists: lists, onListUpload: listUpload, onCancel: closePopoverModal, onAdd: handleAdd, selectedPredicate: type === 'edit' ? getSelectedPredicate(id) : null }))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { style: getStyle(), onClick: () => getRowOnClick() }, children),
        activePopover === `event-${type}-conditions-${id}` &&
            ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, hideNavBar: true },
                React.createElement(src_1.PredicateBuilder, { attributeType: "Event", popOverTargetParent: "root", schemas: selectedSchemas, device: device, listEnabledKeyPaths: listEnabledKeyPaths, lists: lists, onListUpload: listUpload, onCancel: closePopoverModal, onAdd: handleAdd, selectedPredicate: type === 'edit' ? getSelectedPredicate(id) : null })), document.getElementById('mainModalLeft'))));
};
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
    selectedSchemas: reducers_1.getSelectedSchemas(state),
    getSelectedPredicate: (index) => reducers_1.getSelectedPredicate(state, index),
    lists: reducers_1.getDeviceLists(state),
});
const mapDispatchToProps = (dispatch) => ({
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
    addPredicate: (predicate) => dispatch(actions_1.addPredicate(predicate)),
    editPredicate: (index, predicate) => dispatch(actions_1.editPredicate(index, predicate)),
    listUpload: (file) => dispatch(actions_1.uploadDeviceList(file)),
    fetchLists: () => dispatch(actions_1.fetchDeviceLists()),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EventPredicateAddEdit);
